import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { Navigate, resolvePath, useLocation, useNavigate, useParams } from 'react-router-dom';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { translate } from 'i18n/jhipster-language';
import PRow from 'shared/ui/prow';
import PCol from 'shared/ui/pcol';
import OutPutPair from 'shared/ui/output-pair';
import { CreateHeader } from 'shared/ui/dialog-header';
import { getEntity, approveRequest, clearMutationFlags, } from 'shared/lib/reducers/card-replacement-request.reducer';
import { getCmsAccountApproverId } from 'shared/lib/cms-account-approver';
import { APP_LOCAL_DATETIME_FORMAT } from 'app/config/constants';
import moment from 'moment';
const formatDt = (v) => (v ? moment(v).format(APP_LOCAL_DATETIME_FORMAT) : '');
const statusSeverity = (s) => {
    if (!s)
        return null;
    if (s === 'APPROVED' || s === 'COMPLETED')
        return 'success';
    if (s === 'REJECTED' || s === 'CANCELLED')
        return 'danger';
    return 'warning';
};
const mapState = ({ cardReplacementRequest }) => ({
    entity: cardReplacementRequest.entity,
    loadingEntity: cardReplacementRequest.loadingEntity,
    updating: cardReplacementRequest.updating,
    updateSuccess: cardReplacementRequest.updateSuccess,
});
const mapDispatch = {
    loadRequest: getEntity,
    approve: approveRequest,
    clearFlags: clearMutationFlags,
};
const InnerPage = ({ cardId, requestId, entity, loadingEntity, updating, updateSuccess, loadRequest, approve, clearFlags, }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const toast = useRef(null);
    const [approverReason, setApproverReason] = useState('');
    const goToCardDetail = useCallback(() => navigate(resolvePath('../..', location.pathname)), [navigate, location.pathname]);
    useEffect(() => {
        loadRequest(requestId);
    }, [requestId, loadRequest]);
    useEffect(() => () => {
        clearFlags();
    }, [clearFlags]);
    useEffect(() => {
        if (!updateSuccess)
            return;
        toast.current?.show({
            severity: 'success',
            summary: translate('entity.action.successfullyUpdated'),
            life: 2500,
        });
        clearFlags();
        goToCardDetail();
    }, [updateSuccess, clearFlags, goToCardDetail]);
    const row = entity;
    const mismatchedOldCard = row?.oldCardId != null && row.oldCardId !== cardId;
    const canApprove = row?.status === 'REQUESTED' || row?.status === 'PENDING' || row?.status === 'SUBMITTED';
    const onApprove = async () => {
        if (row?.id == null)
            return;
        const reason = approverReason.trim();
        if (!reason) {
            toast.current?.show({
                severity: 'warn',
                summary: translate('form.validation.required'),
                detail: translate('form.approverReason'),
                life: 3000,
            });
            return;
        }
        try {
            const approverId = await getCmsAccountApproverId();
            await approve(row.id, { approverId, approverReason: reason });
        }
        catch (e) {
            console.error(e);
            toast.current?.show({
                severity: 'error',
                summary: translate('general.submit'),
                detail: String(e instanceof Error ? e.message : e),
                life: 4000,
            });
        }
    };
    const content = loadingEntity ? (_jsx(Skeleton, { height: "4rem", className: "mb-3" })) : !row?.id ? (_jsx(PCol, { col: "12", children: translate('general.dtEmptymessage') })) : mismatchedOldCard ? (_jsx(PCol, { col: "12", children: translate('form.replacementWrongCard') })) : (_jsxs(_Fragment, { children: [_jsx(PCol, { col: "12", className: "mb-3", children: _jsx(Tag, { value: row.status ?? '', severity: statusSeverity(row.status ?? undefined) ?? undefined }) }), _jsx(OutPutPair, { labelMd: "3", valueMd: "3", label: "form.cardReference", value: row.oldCard?.cardReference ?? '' }), _jsx(OutPutPair, { labelMd: "3", valueMd: "3", label: "form.maskedPan", value: row.oldCard?.maskedPan ?? '' }), _jsx(OutPutPair, { labelMd: "3", valueMd: "3", label: "form.newCardMaskedPan", value: row.newCard?.maskedPan ?? '' }), _jsx(OutPutPair, { labelMd: "3", valueMd: "3", label: "form.reasonLabel", value: row.reason ?? '' }), _jsx(OutPutPair, { labelMd: "3", valueMd: "3", label: "form.sourceChannel", value: row.sourceChannel ?? '' }), _jsx(OutPutPair, { labelMd: "3", valueMd: "3", label: "form.performedBy", value: row.performedBy ?? '' }), _jsx(OutPutPair, { labelMd: "3", valueMd: "3", label: "form.requestedAt", value: formatDt(row.requestedAt) }), _jsx(OutPutPair, { labelMd: "3", valueMd: "3", label: "form.processedAt", value: formatDt(row.processedAt) }), _jsx(OutPutPair, { labelMd: "3", valueMd: "3", label: "form.approverReason", value: row.approverReason ?? '' }), _jsx(OutPutPair, { labelMd: "3", valueMd: "3", label: "form.createdAt", value: formatDt(row.createdAt) }), _jsx(OutPutPair, { labelMd: "3", valueMd: "3", label: "form.updatedAt", value: formatDt(row.updatedAt) }), canApprove ? (_jsxs(PCol, { col: "12", className: "mt-4 p-field", children: [_jsxs("label", { htmlFor: "replacement-approve-reason", className: "d-block mb-2", children: [translate('form.approverReason'), " *"] }), _jsx(InputTextarea, { id: "replacement-approve-reason", className: "w-full", rows: 3, value: approverReason, onChange: e => setApproverReason(e.target.value) }), _jsx(Button, { type: "button", className: "p-button-success mt-3", label: translate('form.action.approve'), loading: updating, disabled: updating, onClick: () => void onApprove() })] })) : null] }));
    return (_jsx(PRow, { style: { width: '100%' }, className: "p-mt-2 p-px-2", children: _jsxs(PCol, { col: "12", style: { minHeight: 'calc(100vh - 8rem)' }, children: [_jsx(Toast, { ref: toast }), _jsx(BreadCrumb, { home: { icon: 'pi pi-home', command: () => navigate('/') }, model: [
                        { label: translate('form.cms') },
                        {
                            label: translate('form.card'),
                            command: goToCardDetail,
                        },
                        { label: translate('form.cardReplacementRequest') },
                    ] }), _jsx(CreateHeader, { headername: translate('form.cardReplacementRequest') }), _jsx(PRow, { className: "mt-4", children: content }), _jsx(PRow, { className: "mt-4", children: _jsx(Button, { type: "button", label: translate('entity.action.back'), className: "p-button-secondary", icon: "pi pi-arrow-left", onClick: () => goToCardDetail() }) })] }) }));
};
const CardReplacementRequestDetailPage = (props) => {
    const params = useParams();
    const cardId = params.cardId != null && params.cardId !== '' ? Number(params.cardId) : NaN;
    const requestId = params.requestId != null && params.requestId !== '' ? Number(params.requestId) : NaN;
    if (Number.isNaN(cardId) || cardId < 1 || Number.isNaN(requestId) || requestId < 1) {
        return _jsx(Navigate, { to: "..", replace: true });
    }
    return _jsx(InnerPage, { ...props, cardId: cardId, requestId: requestId });
};
export default connect(mapState, mapDispatch)(CardReplacementRequestDetailPage);
